const strokeWidth = {
  name: "stroke-width",
  path: "/stroke-width",
  title: "stroke-width",
  description: "Utilities for styling the stroke width of SVG elements.",
  value: {
  "stroke-width": {
    'stroke-<number>': "<number>",
    'stroke-[<value>]': "<value>",
  }
},
  exampleData: [
    {
      example: {
        code: `<svg class="stroke-1 ..."></svg>
<svg class="stroke-2 ..."></svg>`
      }
    },
    {
      example: {
        code: `<svg class="stroke-[1.5] ..."></svg>`
      }
    },
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">stroke-<var>&lt;number&gt;</var></code> utilities like stroke-1 and stroke-2 to set the stroke width of an SVG:
      </p>
      <div class="flex items-center justify-center gap-x-8">
        <svg class="stroke-color-indigo-500 stroke-1" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
            <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
            <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
            <path d="M1 24H47"></path>
        </svg>
        <svg class="stroke-color-indigo-500 stroke-2" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
            <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
            <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
            <path d="M1 24H47"></path>
        </svg>
      </div>
    `
  },
      {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">stroke-<var>&lt;value&gt;</var></code> syntax to set the stroke width based on a completely custom value:
      </p>
      <div class="flex items-center justify-center gap-x-8">
        <svg class="stroke-color-indigo-500 stroke-[1.5]" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
            <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
            <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
            <path d="M1 24H47"></path>
        </svg>
      </div>
    `
  },
]
}
export default strokeWidth;

<div class="sr-only ">
<div class="flex items-center justify-center gap-x-8">
   <svg class="stroke-color-indigo-500 stroke-1" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
      <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
      <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
      <path d="M1 24H47"></path>
   </svg>
   <svg class="stroke-color-indigo-500 stroke-2 stroke-[1.5]" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
      <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
      <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
      <path d="M1 24H47"></path>
   </svg>
</div>
</div>